function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";

// Assets › Create (DS 2026-10-02, tabs settled 2026-10-05, hand-offs 2026-10-07): an image, a clip or a sequence.
// Redesigned 2026-10-08 (PlunkDocs mockups/create-flow-redesign-2026-10-08.html): three columns, one click per starting point.
// Every starting point hands off to its page: Image to /Content/images/new, Clip to /Content/clips/new (direct from a
// product image, or upload a video), Sequence to /Content/sequences/new. The dialog only picks the starting point.

export class CreateMediaSheet extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape") this.props.onClose();
    });
    _defineProperty(this, "openWs", q => {
      if (this.props.onOpenWorkspace) this.props.onOpenWorkspace(q);
    });
    _defineProperty(this, "go", path => {
      if (this.props.onNavigate) this.props.onNavigate(path);else window.location.assign(path);
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKey);
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  way(label, onClick, first) {
    return /*#__PURE__*/React.createElement("button", {
      key: label,
      type: "button",
      className: "cd-way" + (first ? " first" : ""),
      onClick: onClick
    }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "arrow_forward"));
  }
  render() {
    const {
      onClose
    } = this.props;
    const pics = (this.props.assets || []).filter(a => a && a.url && a.kind === "image").map(a => a.latestUrl || a.url);
    const pic = i => pics.length ? pics[i % pics.length] : null;
    const img = (i, cls) => pic(i) ? /*#__PURE__*/React.createElement("img", {
      className: cls,
      src: pic(i),
      alt: "",
      loading: "lazy"
    }) : null;
    const focus = this.props.tab;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop cd-backdrop",
      onClick: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "cd-sheet",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "cd-title",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "cd-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      id: "cd-title"
    }, "What do you want to make?"), /*#__PURE__*/React.createElement("p", null, "Pick a starting point. It opens ready to go, and the result lands in Assets.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cd-close",
      "aria-label": "Close",
      onClick: onClose
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "close"))), /*#__PURE__*/React.createElement("div", {
      className: "cd-cols"
    }, /*#__PURE__*/React.createElement("section", {
      className: "cd-col" + (focus === "image" ? " focus" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "cd-vis"
    }, img(0) || /*#__PURE__*/React.createElement("span", {
      className: "material-icons cd-ph"
    }, "image"), /*#__PURE__*/React.createElement("span", {
      className: "cd-tag"
    }, "Still")), /*#__PURE__*/React.createElement("div", {
      className: "cd-txt"
    }, /*#__PURE__*/React.createElement("h3", null, "Image"), /*#__PURE__*/React.createElement("p", null, "A photo for a site, an ad or a post, sized for every channel.")), /*#__PURE__*/React.createElement("div", {
      className: "cd-ways"
    }, this.way("Describe it", () => this.openWs("?mode=create"), true), this.way("Start from a product", () => this.openWs("?mode=pick")), this.way("Upload a photo", () => this.openWs("?mode=upload")))), /*#__PURE__*/React.createElement("section", {
      className: "cd-col" + (focus === "clip" ? " focus" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "cd-vis dark"
    }, img(1, "dim") || /*#__PURE__*/React.createElement("span", {
      className: "material-icons cd-ph"
    }, "movie"), /*#__PURE__*/React.createElement("span", {
      className: "cd-tag"
    }, "Motion \xB7 8 s to 2 min"), /*#__PURE__*/React.createElement("span", {
      className: "cd-play material-icons",
      "aria-hidden": "true"
    }, "play_arrow")), /*#__PURE__*/React.createElement("div", {
      className: "cd-txt"
    }, /*#__PURE__*/React.createElement("h3", null, "Clip"), /*#__PURE__*/React.createElement("p", null, "A short video. Bring one image to life, or edit your own footage.")), /*#__PURE__*/React.createElement("div", {
      className: "cd-ways"
    }, this.way("Bring an image to life", () => this.go("/Content/clips/new?mode=direct"), true), this.way("Upload a video", () => this.go("/Content/clips/new?mode=upload")))), /*#__PURE__*/React.createElement("section", {
      className: "cd-col" + (focus === "sequence" ? " focus" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "cd-vis strip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "cd-card"
    }, "Your title"), /*#__PURE__*/React.createElement("span", {
      className: "cd-frame"
    }, img(2) || /*#__PURE__*/React.createElement("span", {
      className: "material-icons cd-ph"
    }, "image")), /*#__PURE__*/React.createElement("span", {
      className: "cd-frame"
    }, img(3) || /*#__PURE__*/React.createElement("span", {
      className: "material-icons cd-ph"
    }, "movie")), /*#__PURE__*/React.createElement("span", {
      className: "cd-card end"
    }, "Learn more")), /*#__PURE__*/React.createElement("div", {
      className: "cd-txt"
    }, /*#__PURE__*/React.createElement("h3", null, "Sequence"), /*#__PURE__*/React.createElement("p", null, "A narrated video built from pieces you already have, in every size.")), /*#__PURE__*/React.createElement("div", {
      className: "cd-ways"
    }, this.way("Promo", () => this.go("/Content/sequences/new?purpose=promo"), true), this.way("Tutorial or walkthrough", () => this.go("/Content/sequences/new?purpose=tutorial"))))), /*#__PURE__*/React.createElement("p", {
      className: "cd-foot"
    }, "Everything you make lands in Assets, where you can edit it, tag it and add it to a piece.")));
  }
}
export default CreateMediaSheet;